import './style.css';
import ShoppableContent from '../utils/shoppable-content';

export default (element) => {
  // eslint-disable-next-line no-unused-vars
  const shoppable = new ShoppableContent({ element });
};
